import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import { WA_URL } from '../../lib/wa';

const TRUST_BADGES = ['Established 2025', '3 Global Offices', '1000+ Products', 'Real Consumer Data'];

export const ContactCta = () => (
  <section id="contact" className="py-20 md:py-32 bg-gradient-to-br from-gray-900 via-[#1e3a8a] to-[#004aad] relative overflow-hidden">
    <div className="absolute inset-0 opacity-10">
      <div className="absolute inset-0 shimmer-bg"></div>
    </div>
    <div className="container mx-auto px-6 relative z-10">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Ready to Launch Your Brand in ANZ?
        </h2>
        <p className="text-xl md:text-2xl text-white/90 mb-4">
          Join the growing list of Indian brands successfully scaling into Australia & New Zealand with Atlas.
        </p>
        <p className="text-base md:text-lg text-white/70 mb-6 italic">
          We work on a partnership model — no large upfront fees. Let's talk about what works for your brand.
        </p>

        <div className="inline-flex items-center space-x-2 bg-amber-500 text-white px-6 py-3 rounded-full text-sm md:text-base font-bold mb-8 animate-pulse">
          <span>⚡</span>
          <span>Limited brand slots available per category. We maintain exclusivity.</span>
        </div>

        <div className="mb-10">
          <Button asChild size="lg" className="bg-white hover:bg-gray-100 text-[#004aad] text-lg px-12 py-7 transition-all duration-300 hover:shadow-2xl font-bold text-xl pulse-cta" data-testid="contact-partner-btn">
            <a href={WA_URL} target="_blank" rel="noopener noreferrer">
              Partner With Atlas
              <ArrowRight className="ml-2 h-6 w-6" />
            </a>
          </Button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-white/80 text-sm">
          {TRUST_BADGES.map((b) => (
            <div key={b} className="flex items-center space-x-2">
              <span className="text-amber-400">✦</span>
              <span>{b}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
